'use client';

import type { ICollectionPipelineStatusV3 } from '@repo/sdk';
import type { JSX } from 'react';
import { PipelineStepBadge } from '../pipeline-step-badge';
import { PipelineStepCell } from '../pipeline-step-cell';
import { PipelineStepDialog } from '../pipeline-step-dialog';

interface IUploadStepProps {
  item: ICollectionPipelineStatusV3;
}

export function UploadStep({ item }: IUploadStepProps): JSX.Element {
  const { clipsUploaded } = item.steps;
  return (
    <PipelineStepCell
      badge={<PipelineStepBadge step={clipsUploaded} />}
      renderDialog={(open, onOpenChange) => (
        <PipelineStepDialog
          open={open}
          onOpenChange={onOpenChange}
          title="Uploaded"
          description={`Cropped clips uploaded to R2 and ready to serve. Uploaded automatically by the vault after a successful crop. ${clipsUploaded.done}/${clipsUploaded.total} uploaded.`}
          dataHref={`/sys/media?collectionId=${item.collectionId}`}
          dataLabel="Open clips"
        />
      )}
    />
  );
}
